export default class IPConstants {
  constructor() { }
  static successMessage = "Ok!";
  static failedMessage = "failed";

  static editTooltipMessage = "어쩌구 저쩌구 이러쿵 저러쿵\r\n그래서 이래서 저래서";
  static generalTooltipMessage = "시스템상의 기준이나 작업표즌, 지침, 절차, 규정등을 충족한 상태";
  static regulationTooltipMessage = "관계법령, 고시등으로부터 벗어난 상태";
  static instructionTooltipMessage = "내부 규정등으로부터 벗어난 상태";
  static recommendationTooltipMessage = "개선의 여지가 있는 경우 또는 운영상 비효울적이거나 불합리하다고 판단되는 경우";
}